import React, { useContext, useEffect } from "react";

import { StemGridded } from "@examspark/types";

import QuestionContext from "../QuestionContext";

import ItemBubble from "./ItemBubble";
import Prompt from "./shared/Prompt";

export interface GriddedProps {
  data: StemGridded;
}

const Gridded: React.FC<React.PropsWithChildren<GriddedProps>> = (props) => {
  const [player, dispatchPlayer] = useContext(QuestionContext);

  // Reveal Key
  useEffect(() => {
    if (player.revealKey) {
      dispatchPlayer({
        type: "RESPONSE",
        data: {
          id: props.data.id,
          score: true,
          response: props.data.scoring?.values?.[0],
        },
      });
    }
  }, [player.revealKey]);

  return (
    <div className="item-player-element item-player-stem">
      <Prompt data={props.data.content.prompt} />
      <ItemBubble
        value={player.response?.[props.data.id] || "       "}
        columns={7}
        onChange={(value) => {
          console.log("value", value);
          dispatchPlayer({
            type: "RESPONSE",
            data: {
              id: props.data.id,
              response: value,
            },
          });
        }}
      />
    </div>
  );
};
export default Gridded;
